import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { Button } from "@/components/wpl/button/src/button";
import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";

const containerStyle = css({
    boxSizing: "border-box",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    maxWidth: "1200px",
    padding: "16px",
    fontFamily:
        "Charlie Display, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif"
});

const innerContainerStyle = css({
    alignContent: "flex-start",
    boxSizing: "border-box",
    display: "flex",
    flexBasis: "0%",
    flexGrow: "2",
    flexShrink: "1",
    flexWrap: "wrap",
    maxWidth: "628px",
    minWidth: "50%"
});

const textContainer = css({
    marginBlockStart: "5px",
    marginBlockEnd: "3px",
    fontSize: "20px",
    fontWeight: "400",
    letterSpacing: "0.3px",
    lineHeight: "28px",
    verticalAlign: "baseline",
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#42526e"
});

const buttonStyle = css({
    margin: `${token("space.0")} ${token("space.0")} ${token(
        "space.200"
    )} ${token("space.0")}`,
    fontWeight: "500",
    minHeight: 40,
    textWrap: "wrap",
    verticalAlign: "baseline",
    whiteSpaceCollapse: "collapse",
    // eslint-disable-next-line local/ensure-wac-token-usage
    fontFamily: "var(--bxp-charlie-text-font-family)",
    marginBlockEnd: "24px"
});

const buttonContainer = css({
    marginBlockStart: "40px"
});

const BillingLicensing = () => {
    const intl = useIntl();
    const contactSupportText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.billing-licensing.contact-support",
        defaultMessage: "Contact support"
    });
    const billingText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.billing-licensing.billing",
        defaultMessage: `If you’re wondering how billing works for a product you’d like to purchase, select “pricing & quotes”.`
    });
    const assistanceText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.billing-licensing.assitance",
        defaultMessage:
            "For assistance with products you already own, please raise a support ticket."
    });

    return (
        <div css={containerStyle}>
            <div css={innerContainerStyle}>
                <div css={textContainer}>
                    <p>{billingText}</p>
                    <p>{assistanceText}</p>
                </div>
                <p css={buttonContainer}>
                    <Button
                        text={contactSupportText}
                        aria-label={contactSupportText}
                        css={buttonStyle}
                        color="darkblue"
                        url={useLocalizedHref(
                            "/company/contact/purchasing-licensing"
                        )}
                        dataEventProps={{
                            "data-product-key": "jiraSoftwareFeature",
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-label": contactSupportText
                        }}
                    />
                </p>
            </div>
        </div>
    );
};

export default BillingLicensing;
